// extracted by mini-css-extract-plugin
export default {"displayOnlyOnMobile":"Clients_displayOnlyOnMobile__jkZKg","clientsSocialText":"Clients_clientsSocialText__5Nbku","clientsLogos":"Clients_clientsLogos__nUq2R"};